<template>
    <div>
      <vs-prompt
      @cancel="canceld"
      @accept="accepted"
      @close="closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddCreditor"
      :is-valid="formValid"
      style="z-index:30002">
       <div>
        <div>
          <p>{{$t('ADD_CREDITOR.HEADER.TEXT')}}</p>
          <div class="default-input d-flex align-items-center">{{$t('ADD_CREDITOR.CREDITOR_NUMBERGROUP')}}: 
            <vs-select :disabled="creditor_nr.length > 0 && numbergroup_fk > 0" v-model="numbergroup_fk" class="ml-2">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in numbergroups" />
            </vs-select>          
          </div>
          <div class="default-input d-flex align-items-center">{{$t('ADD_CREDITOR.CREDITOR_NUMBERGROUP_ARTICLE')}}: 
            <vs-select :disabled="article.length > 0 && numbergroup_article_fk > 0" v-model="numbergroup_article_fk" class="ml-2">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in numbergroups_article" />
            </vs-select>          
          </div>   
 
          <vs-tabs v-model="activeTab">
            <vs-tab :label="$t('ADD_CREDITOR.TAB.CREDITOR')">
              <vs-divider >{{$t('ADD_CREDITOR.DIVIDER.COMPANY')}}</vs-divider>
              <div  class="default-input clearfix align-items-center mb-3">
                <vs-input ref="name" :label="$t('ADD_CREDITOR.LABEL.NAME')" class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.NAME')"  v-model="name" />
                <vs-input :label="$t('ADD_CREDITOR.LABEL.NAME_SHORT')" class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.NAME_SHORT')"  v-model="name_short" />
                <vs-input :label="$t('ADD_CREDITOR.LABEL.NAME_INTERNAL')" class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.NAME_INTERNAL')"  v-model="name_internal" />
                <vs-input :label="$t('ADD_CREDITOR.LABEL.UID')"  class="float-left inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.UID')"  v-model="uid" />
              </div>
              <vs-divider>{{$t('ADD_CREDITOR.DIVIDER.TEL_EMAIL')}}</vs-divider>
              <div class="default-input clearfix align-items-center mb-3">
                <vs-input :label="$t('ADD_CREDITOR.LABEL.TEL')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.TEL')"  v-model="tel" :danger="tel_fail" val-icon-danger="clear" :danger-text="$t('ADD_CREDITOR.TEL_FAIL')" />
                <vs-input :label="$t('ADD_CREDITOR.LABEL.EMAIL')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.EMAIL')"  v-model="email" :danger="emailFail" val-icon-danger="clear" />
              </div>
              <vs-textarea height="200px" counter="2500" :label="$t('ADD_CREDITOR.LABEL.DESCRIPTION')" v-model="description" />            
            </vs-tab>
            <vs-tab :label="$t('ADD_CREDITOR.TAB.CONTACT')">
              <vs-divider>{{$t('ADD_CREDITOR.DIVIDER.TITEL')}}</vs-divider>
              <div class="default-input clearfix align-items-center mb-3">
                <vs-input ref="title_contact" :label="$t('ADD_CREDITOR.LABEL.TITLE_CONTACT')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.TITLE_CONTACT')"  v-model="title_contact"  />
                <vs-input :label="$t('ADD_CREDITOR.LABEL.TITLE_CONTACT_POST')"  class="float-left inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.TITLE_CONTACT_POST')"  v-model="title_contact_post" />
              </div>
              <vs-divider>{{$t('ADD_CREDITOR.DIVIDER.NAME')}}</vs-divider>
              <div class="clearfix align-items-center mb-3">
                <vs-input :label="$t('ADD_CREDITOR.LABEL.FIRSTNAME')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.FIRSTNAME')"  v-model="firstname_contact" :danger="firstname_contact_fail" val-icon-danger="clear"/>
                <vs-input :label="$t('ADD_CREDITOR.LABEL.LASTNAME')"  class="float-left inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.LASTNAME')" v-model="lastname_contact" :danger="lastname_contact_fail" val-icon-danger="clear"/>
              </div>
              <vs-divider>{{$t('ADD_CREDITOR.DIVIDER.TEL_EMAIL')}}</vs-divider>
              <div class="default-input clearfix align-items-center mb-3">
                <vs-input :label="$t('ADD_CREDITOR.LABEL.TEL_CONTACT')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.TEL_CONTACT')"  v-model="tel_contact" :danger="tel_contact_fail" val-icon-danger="clear" :danger-text="$t('ADD_CREDITOR.TEL_CONTACT_FAIL')" />
                <vs-input :label="$t('ADD_CREDITOR.LABEL.EMAIL_CONTACT')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.EMAIL_CONTACT')"  v-model="email_contact" :danger="email_contactFail" val-icon-danger="clear" />
              </div>            
            </vs-tab>            
            <vs-tab :label="$t('ADD_CREDITOR.ADDRESS')">
                  <div class="default-input clearfix align-items-center mt-3 mb-3">
                    <vs-input ref="street1" :label="$t('ADD_CREDITOR.LABEL.STREET1')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.STREET1')"  v-model="street1" :danger="street1_fail" val-icon-danger="clear"/>
                    <vs-input :label="$t('ADD_CREDITOR.LABEL.STREET2')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.STREET2')"  v-model="street2" />
                  </div>
                  <div class="default-input clearfix align-items-center mb-3">
                    <vs-input :label="$t('ADD_CREDITOR.LABEL.PLZ')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.PLZ')"  v-model="plz" :danger="plz_fail" val-icon-danger="clear"  :danger-text="$t('ADD_CREDITOR.PLZ_FAIL')"/>
                    <vs-input :label="$t('ADD_CREDITOR.LABEL.CITY')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.LABEL.PLACEHOLDER.CITY')"  v-model="city" :danger="city_fail" val-icon-danger="clear"/>
                  </div>
                  <div class="default-input clearfix align-items-center mb-3">
                    <vs-select :label="$t('ADD_CREDITOR.LABEL.COUNTRY')" v-model="country_fk" class="float-left" :danger="country_fk_fail">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in countries" />
                    </vs-select>
                  </div>
            </vs-tab>
          </vs-tabs>
        </div>
        <div class="d-flex">
          <vs-button v-if="activeTab > 0 " class="mr-3" type="filled" icon="arrow_back_ios" @click="back()">{{$t('COM.BACK')}}</vs-button>
          <vs-button v-if="activeTab < idLastTab" type="filled" icon="arrow_forward_ios" @click="next()">{{$t('COM.NEXT')}}</vs-button>
        </div>
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import enumHelper from '../../../helper/enumHelper';
import {numbergroup_Types} from '../../../helper/enumHelper';

export default {
  name: "AddCreditorDlg",
  props:['InitData'],
  data: function (){
     return {
       id:0,
       numbergroups:[],
       numbergroup_fk:-1,
       numbergroups_article:[],
       numbergroup_article_fk:-1,       
       numbergroupOk: false,
       numbergroupArticleOk: false,
       creditor_nr:"",
       defaultNrGrpFk:-1,
       defaultArticleNrGrpFk:-1,
       dlgActive: false,
       activeTab: 0,
       idLastTab: 2,
       title_contact:"",
       title_contact_post:"",
       firstname_contact:"",
       firstname_contact_fail:false,
       firstname_contact_ok:false,
       lastname_contact:"",
       lastname_contact_fail:false,
       lastname_contact_ok:false,
       uid:"",
       uid_fail:false,
       uid_ok:false,       
       name:"",
       name_fail:false,
       name_ok:false,       
       tel:"",
       tel_fail:false,
       tel_ok:false,
       tel_contact:"",
       tel_contact_fail:false,
       tel_contact_ok:false,       
       email:"",
       emailOkay:true,
       emailFail:false,
       email_contact:"",
       email_contactOkay:true,
       email_contactFail:false,       
       street1:"",
       street1_fail:false,
       street1_ok:false,
       street2:"",
       plz:"",
       plz_fail:false,
       plz_ok:false,
       city:"",
       city_fail:false,
       city_ok:false,
       country_fk:-1,
       country_fk_fail:false,
       country_fk_ok:false,      
       popupTitle: this.$t('ADD_CREDITOR.TITLE'),
       description:"",
       name_internal:"",
       name_short:"",
       article:[]

     }
  }, 
  mounted () {
    this.$store.dispatch('numbergroup/getNumbergroupsByCompany',0,{ root: true });// Companyid des aktuellen users im backend ermitteln
    this.ClearForm();
    
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      next(){
        this.activeTab += 1;
      },
      back(){
        this.activeTab -= 1;
      },
      showDlg(){
        this.ClearForm();

          if(this.defaultNrGrpFk != -1)
          {
            this.numbergroup_fk = this.defaultNrGrpFk;
          }

          if(this.defaultArticleNrGrpFk != -1)
          {
            this.numbergroup_article_fk = this.defaultArticleNrGrpFk;
          }

        this.dlgActive=true;
      },
      closed(){
        this.ClearForm();
      },
      InitDlgData(data){
        
        if(this.IsNotNull(data))
        {

          this.id = data.id;
          this.firstname_contact = data.firstname_contact;
          this.lastname_contact = data.lastname_contact;

          this.title_contact = data.title_contact;
          this.title_contact_post = data.title_contact_post;
          this.uid = data.uid;
          this.name = data.name;
          this.comapany_fk = data.comapany_fk;
          this.tel = data.tel;
          this.tel_contact = data.tel_contact;
          this.email = data.email;
          this.email_contact = data.email_contact;
          this.numbergroup_fk = data.numbergroup_fk;
          this.numbergroup_article_fk = data.numbergroup_article_fk;
          this.creditor_nr = data.creditor_nr;
          this.street1 = data.address.street1;
          this.street2 = data.address.street2;
          this.plz = data.address.plz;
          this.city = data.address.city;
          this.country_fk = data.address.country_fk;
          this.description = data.description;
          this.name_short = data.name_short;
          this.name_internal = data.name_internal;
          this.article = data.article;
          this.popupTitle = this.$t('ADD_CREDITOR.TITLE.EDIT') + ' ('+this.creditor_nr+')';

          this.dlgActive=true;
        }
      },
      accepted(){

          var data = {

          id : this.id,
          firstname_contact : this.firstname_contact,
          lastname_contact : this.lastname_contact,

          title_contact : this.title_contact,
          title_contact_post : this.title_contact_post,
          uid : this.uid,
          name : this.name,
          comapany_fk : this.comapany_fk,
          tel : this.tel,
          tel_contact : this.tel_contact,
          email : this.email,
          email_contact : this.email_contact,
          numbergroup_fk : this.numbergroup_fk,
          numbergroup_article_fk : this.numbergroup_article_fk,
          creditor_nr : this.creditor_nr,
          address:{
            street1 : this.street1,
            street2 : this.street2,
            plz : this.plz,
            city : this.city,
            country_fk : this.country_fk
          },
          description : this.description,
          name_short : this.name_short,
          name_internal : this.name_internal,
          };

          var name = this.firstname + ' ' + this.lastname;
          this.$store.dispatch('creditor/saveCreditor', data)
          .then(response => {
            if(response.success === true)
            {
                this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('CREDITORS.SUCCESS.SAVE').replace("*1*",name)});  
            }
            else
            {
              var text = this.$t('CREDITORS.WARNING.SAVE').replace("*1*",name);
              text = text.replace("*2*",this.$t(response.text));
              this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
            }
            this.$emit('Accepted',response.id);
          }, 
          error =>{
              var text = this.$t('CREDITORS.ERROR.SAVE').replace("*1*",name);
              text = text.replace("*2*",error);
              this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':text});  
              this.$emit('Accepted');
          });
          
          this.ClearForm();
      },
      canceld(){
        this.ClearForm();
      },
      isNameFail(name,isMustHave){
        var fail = false;
        if(isMustHave)
        {
          if(name.length > 0)
          {
              if(!this.ContainNoNumbers(name))
              {
                // Name enthält Zahlen
                fail = true;
              }
          }
          else
          {
            fail = true;
          }
        }
        else
        {
         fail = !this.ContainNoNumbers(name);
        }
        return fail;
      },
      ClearForm(){
       this.id=0;
       this.creditor_nr = "";
       this.defaultNrGrpFk = -1;
       this.defaultArticleNrGrpFk = -1;
       this.dlgActive =  false;
       this.activeTab =  0;
       this.idLastTab =  2;
       this.title_contact = "";
       this.title_contact_post = "";
       this.firstname_contact = "";
       this.firstname_contact_fail = false;
       this.firstname_contact_ok = false;
       this.lastname_contact = "";
       this.lastname_contact_fail = false;
       this.lastname_contact_ok = false;
       this.uid = "";
       this.uid_fail = false;
       this.uid_ok = false;       
       this.name = "";
       this.name_fail = false;
       this.name_ok = false;       
       this.tel = "";
       this.tel_fail = false;
       this.tel_ok = false;
       this.tel_contact = "";
       this.tel_contact_fail = false;
       this.tel_contact_ok = false;       
       this.email = "";
       this.emailOkay = true;
       this.emailFail = false;
       this.email_contact = "";
       this.email_contactOkay = true;
       this.email_contactFail = false;       
       this.street1 = "";
       this.street1_fail = false;
       this.street1_ok = false;
       this.street2 = "";
       this.plz = "";
       this.plz_fail = false;
       this.plz_ok = false;
       this.city = "";
       this.city_fail = false;
       this.city_ok = false;
       this.country_fk = -1;
       this.country_fk_fail = false;
       this.country_fk_ok = false;      
       this.description = "";
       this.name_internal = "";
       this.name_short = "";
       this.article = [];

        if(this.countries.length > 1 )
        {
          this.country_fk = this.countries[1].value;
          this.country_fk_ok = true;
        }

        this.popupTitle = this.$t('ADD_CREDITOR.TITLE');
      }
  },
  computed:{
    countries(){
      return this.GetListOfCountriesForSelect(false);
    },
    formValid(){
        var valid = this.firstname_contact_ok && 
        this.lastname_contact_ok && this.emailOkay && 
        this.email_contactOkay && this.tel_ok &&
        this.tel_contact_ok && this.street1_ok && this.plz_ok && 
        this.city_ok && this.country_fk_ok && this.numbergroupOk && 
        this.uid_ok && this.numbergroupArticleOk;
        valid = true;
        return valid;
    },
    numbergroupsForSelect(){
      return this.GetListOfNumbergroupsForSelect(numbergroup_Types.LIEFERANT);
    },
    numbergroupsForArticleSelect(){
      return this.GetListOfNumbergroupsForSelect(numbergroup_Types.ARTIKEL);
    },    
  },
  watch:{
    activeTab(value){
      switch(value)
      {
        case 0:
          this.$nextTick(() => this.setFocusOnInput('name'));
          break;
        case 1:
          this.$nextTick(() => this.setFocusOnInput('title_contact'));
          break;
        case 2:
          this.$nextTick(() => this.setFocusOnInput('street1'));
          break;          
      }
    },
    numbergroupsForSelect(value)
    {
        this.numbergroups = value.numbergroups;
        this.defaultNrGrpFk = value.default;
    },
    numbergroupsForArticleSelect(value)
    {
        this.numbergroups_article = value.numbergroups;
        this.defaultArticleNrGrpFk = value.default;
    },    
    firstname_contact(value)
    {
      this.firstname_contact_fail = this.isNameFail(value,true);
      this.firstname_contact_ok = !this.firstname_contact_fail;
    },
    lastname_contact(value)
    {
      this.lastname_contact_fail = this.isNameFail(value,true);
      this.lastname_contact_ok = !this.lastname_contact_fail && value.length > 0;
    },
    tel(value)
    {
      this.tel_fail = value.length == 0 || !this.ValidatePhone(value);
      this.tel_ok = !this.tel_fail;
    },
    tel_contact(value)
    {
      this.tel_contact_fail = value.length == 0 || !this.ValidatePhone(value);
      this.tel_contact_ok = !this.tel_contact_fail;
    },
    email(value){

      this.emailOkay = this.ValidateEmail(value) || value == "";
      this.emailFail = !this.emailOkay;
    },
    email_contact(value){

      this.email_contactOkay = this.ValidateEmail(value) || value == "";
      this.email_contactFail = !this.email_contactOkay;
    },
    uid(value){
      this.uid_fail = value.length == 0;
      this.uid_ok = !this.uid_fail;
    },    
    street1(value){
      this.street1_fail = value.length == 0;
      this.street1_ok = !this.street1_fail;
    },
    plz(value){
      this.plz_fail = value.length == 0 || !this.ContainNumbersOnly(value);
      this.plz_ok = !this.plz_fail;
    },
    city(value){
      this.city_fail = value.length == 0;
      this.city_ok = !this.city_fail;
    },
    country_fk(value){
      this.country_fk_fail = value <= 0;
      this.country_fk_ok = !this.country_fk_fail;
    },
    numbergroup_fk(value)
    {
       this.numbergroupOk = value > 0
    },
    numbergroup_article_fk(value)
    {
       this.numbergroupArticleOk = value > 0
    }
  }
};
</script>
<style>
div#promptAddCreditor > div.vs-dialog{
  max-width: 800px !important;
}
div#promptAddCreditor > div.vs-dialog > 
div.vs-dialog-text > div > div > 
div.vs-tabs > div.con-slot-tabs > div.vs-tabs--content{
min-height: 450px;
}
</style>